"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teeTimeKeyToFriendly = void 0;
const teeTimeKeyToFriendly = (key) => {
    switch (key) {
        case "cheapest":
            return "Cheapest";
        case "early_morning":
            return "Early Morning";
        case "late_morning":
            return "Late Morning";
        case "Afternoon":
            return "Afternoon";
        default:
            return "";
    }
};
exports.teeTimeKeyToFriendly = teeTimeKeyToFriendly;
